/* ════════════════════════════════════════════════════════════════
   About — an inked comic narration panel holding the lead prose and a
   mono "spec sheet", with tilted stat-tile panels below.
   ════════════════════════════════════════════════════════════════ */
import { SectionSide, CountUp } from '../ui/primitives';
import { PROJECTS } from '../data/site';

const INFO = [
  { k: 'role',     v: 'Front-End Engineer' },
  { k: 'location', v: 'Queens, NY' },
  { k: 'focus',    v: 'Interactive UI · AI integration' },
  { k: 'status',   v: 'Open to work', ok: true },
];

export default function About({ commitCount }) {
  return (
    <section className="section section--split" id="about">
      <SectionSide num="01" title="About Me" />
      <div className="section-content">
        <div className="about reveal">
          <div className="about-panel">
            <p className="about-lead">
              I build <span className="about-hl">clean, interactive</span> web
              experiences — bringing creative ideas to life through code, and
              pushing into <span className="about-hl">AI-driven</span> interfaces
              that make users feel like they're living in the future.
            </p>
            <ul className="about-specs">
              {INFO.map(({ k, v, ok }) => (
                <li className="spec-row" key={k}>
                  <span className="spec-key">{k}</span>
                  <span className="spec-dots" aria-hidden="true" />
                  <span className={`spec-val${ok ? ' spec-val--ok' : ''}`}>
                    {ok && <span className="spec-dot" />}{v}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          <div className="about-stats">
            <div className="stat-tile">
              <span className="stat-num"><CountUp target={1} /></span>
              <span className="stat-label">Years Exp.</span>
            </div>
            <div className="stat-tile">
              <span className="stat-num"><CountUp target={PROJECTS.length} /></span>
              <span className="stat-label">Projects</span>
            </div>
            <div className="stat-tile">
              <span className="stat-num">
                {commitCount !== null ? <CountUp target={commitCount} /> : '…'}
              </span>
              <span className="stat-label">Commits</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
